































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PaginationPanel, DataPanel } from "@/components";
import SearchPanel from "@/components/SearchPanel.vue";
import { formRules, vform } from "@/common/util/validator";
import dayjs from 'dayjs';
import { Public } from "@/http/api_Public";
import { fmoney } from "@/common/util/money";
var fileDownload = require("js-file-download");
@Component({
  components: {
    SearchPanel,
    DataPanel,
    PaginationPanel,
  },
})
export default class commodityInfo extends Vue {
  fmoney = fmoney;
  timeValue = [];
  /**登陆信息 */
  public userInfo = JSON.parse(localStorage.getItem("userInfo"));
  /**正则方法 */
  public formRules: any = formRules;
  /**请求加载判断 */
  public loading: boolean = false;
  // 右对齐
  public labelPosition: string = "right";
  /**刷新 */
  public rePagin: boolean = false;
  /**列表数据 */
  public listData = [];
  /**数据总数 */
  public total: number = 0;
  totalForm = {};
  public $refs!: {
    form: HTMLFormElement;
  };
  // 搜索字段
  public searchValue = {
    shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
    name:"",
    goodsClassId:"",
    skip:0,
    count:10,
    isShelves:null,
  };
  exloading = false;
  statusOptions=[
      {
          label:"上架中",
          value:true,
      },
      {
          label:"已下架",
          value:false,
      },
  ]

  //所属分类的name名字总和
    departvalue = []
    // 所属分类选择
    classOptions:any = []

  async mounted() {
    await this.getlist();
    await this.getClassList();
  }
  activated() {}
  // beforeDestroy(){
  //     window.removeEventListener('handleEnter',this.handleSearch,false) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
  // }

  /**获取列表信息 */
  public async getlist() {
    this.loading = true;
    let result = await Public.GetGoodsItemsList(this.searchValue);
    let result2 = await Public.GetGoodsItemsListForTotal(this.searchValue);
    this.listData = result.items;
    this.total = result.totalCount;
    this.totalForm = result2;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  /**商品分类 */
  async getClassList() {
    let res = await Public.GetAllGoodsClassList({});
    this.classOptions = res.map((v) => {
      return {
        ...v,
        children: v.items,
      };
    });
  }
  async handleChange(value) {
    if(value.length==0){
        const _cascader = this.$refs['cascaderHandle'];
        if (_cascader) {
            _cascader.$refs.panel.checkedValue = []
            _cascader.$refs.panel.activePath = []
            _cascader.$refs.panel.syncActivePath()
        }
    }
    if (value.length > 0) {
      console.log(value);
      if (value.length == 1) {
        this.searchValue.goodsClassId = value[0];
      } else {
        this.searchValue.goodsClassId = value[1];
      }
    } else {
      this.searchValue.goodsClassId = "";
    }
    this.$refs['cascaderHandle'].dropDownVisible = false;
  }
  // 点击搜索
  public async handleSearch() {
    this.rePagin = false;
    Object.assign(this.searchValue, { skip: 0, count: 10 });
    await this.getlist();
    this.rePagin = true;
  }
  // 重置
  public async onReset() {
    this.rePagin = false;
    this.searchValue = {
      shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
      name:"",
      goodsClassId:"",
      skip:0,
      count:10,
      isShelves:null,
    };
    this.departvalue = [];
    const _cascader = this.$refs['cascaderHandle']
    if (_cascader) {
        _cascader.$refs.panel.checkedValue = []
        _cascader.$refs.panel.activePath = []
        _cascader.$refs.panel.syncActivePath()
    }
    await this.getlist();
    this.rePagin = true;
  }
  public async onPaginationChange(page) {
    let { skip, count } = page;
    Object.assign(this.searchValue, { skip, count });
    await this.getlist();
  }
  /**统计合计 */
    getSummaries(param) {
      const { columns, data } = param;
      const sums:any = [];
      let sumTotal = this.jsHj();

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = `合计  负库存不纳入合计`;
              return;
          }
          sums[index] = sumTotal[column.property];
      });

      return sums;
    }
    jsHj() {
      let form = {
          stock: '',
          stockSell: '',
          stockCost:'',
      },
      arr = this.listData;
      if (arr.length > 0) {
          form = {
              stock: this.totalForm['stock']?this.totalForm['stock']:0,
              stockSell:this.totalForm['stockSell']?fmoney(this.totalForm['stockSell'],2):'0.00',
              stockCost:this.totalForm['stockCost']?fmoney(this.totalForm['stockCost'],2):'0.00',
          };
      }
      return form;
    }
  export_table() {
    try {
      this.exloading = true;
      Public.GetGoodsItemsOverviewReport(Object.assign({},this.searchValue,{
        skip:0,
        count:-1,
        articleNo:this.searchValue.name
      })).then((res) => {
        var fileName = "商品库存报表";
        fileDownload(res.data, fileName + ".xls");
        this.exloading = false;
      });
    } catch (error) {
      this.exloading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/commodityInfo/index.vue